import React from 'react';
import { Radio as AntdRadio, RadioGroupProps, RadioProps } from 'antd';

const Radio = (props: RadioProps) => <AntdRadio {...props} className={`bringg-radio ${props.className || ''}`} />;
Radio.Group = (props: RadioGroupProps) => <AntdRadio.Group {...props} />;
Radio.Button = (props: React.ComponentProps<typeof AntdRadio.Button>) => (
	<AntdRadio.Button {...props} className={`bringg-radio ${props.className || ''}`} />
);

export default Radio;
